import {
    GET_GENRE_FILTERS,
    GET_STATUS_FILTERS,
    GET_TYPE_FILTERS,
    GET_CINEMA_FILTERS,
    GET_DISTRIBUTORS,
    GET_STUDIOS,
    GET_GENRE_FILTERS_SUCCEEDED,
    GET_STATUS_FILTERS_SUCCEEDED,
    GET_TYPE_FILTERS_SUCCEEDED,
    GET_CINEMA_FILTERS_SUCCEEDED,
    GET_DISTRIBUTORS_SUCCEEDED,
    GET_STUDIOS_SUCCEEDED,
    GET_CINEMA_LOCATIONS,
    GET_CINEMA_LOCATIONS_SUCCEEDED,
    STORE_CINEMA_LOCATION,
    STORE_CINEMA_LOCATION_SUCCEEDED,
    STORE_SELECTED_FESTIVAL_DATE,
    STORE_SELECTED_FESTIVAL_DATE_SUCCEEDED,
    STORE_SELECTED_EVENT_LOCATION,
    STORE_SELECTED_EVENT_LOCATION_SUCCEEDED,
    STORE_SELECTED_MOVIE_FILTERS,
    STORE_SELECTED_MOVIE_FILTERS_SUCCEEDED,
    STORE_SELECTED_MOVIES_SORT_BY,
    STORE_SELECTED_MOVIES_SORT_BY_SUCCEEDED,
    GET_SOON_IN_CINEMA_FILTERS,
    GET_SOON_IN_CINEMA_FILTERS_SUCCEEDED,
    GET_BOX_OFFICE_GENRE_FILTERS_SUCCEEDED,
    GET_BOX_OFFICE_GENRE_FILTERS,
    STORE_SELECTED_HOUR,
    STORE_SELECTED_HOUR_SUCCEEDED,
    STORE_SELECTED_DATE,
    STORE_SELECTED_DATE_SUCCEEDED,
    REDIRECT_URL,
    REDIRECT_URL_SUCCEEDED,
} from "./types";

export const getGenreFilters = (payload) => ({
    type: GET_GENRE_FILTERS,
    payload,
});

export const getStatusFilters = (payload) => ({
    type: GET_STATUS_FILTERS,
    payload,
});

export const getTypeFilters = (payload) => ({
    type: GET_TYPE_FILTERS,
    payload,
});

export const getCinemaFilters = (payload) => ({
    type: GET_CINEMA_FILTERS,
    payload,
});

export const getDistributors = (payload) => ({
    type: GET_DISTRIBUTORS,
    payload,
});

export const getStudios = (payload) => ({
    type: GET_STUDIOS,
    payload,
});

export const getGenreFiltersSucceeded = (payload) => ({
    type: GET_GENRE_FILTERS_SUCCEEDED,
    payload
});

export const getStatusFiltersSucceeded = (payload) => ({
    type: GET_STATUS_FILTERS_SUCCEEDED,
    payload
});

export const getTypeFiltersSucceeded = (payload) => ({
    type: GET_TYPE_FILTERS_SUCCEEDED,
    payload
});

export const getCinemaFiltersSucceeded = (payload) => ({
    type: GET_CINEMA_FILTERS_SUCCEEDED,
    payload
});

export const getDistributorsSucceeded = (payload) => ({
    type: GET_DISTRIBUTORS_SUCCEEDED,
    payload
});

export const getStudiosSucceeded = (payload) => ({
    type: GET_STUDIOS_SUCCEEDED,
    payload
});

export const getCinemaLocations = (payload) => ({
    type: GET_CINEMA_LOCATIONS,
    payload
})

export const getCinemaLocationsSucceeded = (payload) => ({
    type: GET_CINEMA_LOCATIONS_SUCCEEDED,
    payload
})

export const storeSelectedCinemaLocation = (payload) => ({
    type: STORE_CINEMA_LOCATION,
    payload
})

export const storeSelectedCinemaLocationSucceeded = (payload) => ({
    type: STORE_CINEMA_LOCATION_SUCCEEDED,
    payload
})

export const storeSelectedFestivalDate = (payload) => ({
    type: STORE_SELECTED_FESTIVAL_DATE,
    payload
})

export const storeSelectedFestivalDateSucceeded = (payload) => ({
    type: STORE_SELECTED_FESTIVAL_DATE_SUCCEEDED,
    payload
})

export const storeSelectedEventLocation = (payload) => ({
    type: STORE_SELECTED_EVENT_LOCATION,
    payload
})

export const storeSelectedEventLocationSucceeded = (payload) => ({
    type: STORE_SELECTED_EVENT_LOCATION_SUCCEEDED,
    payload
})

export const storeSelectedMovieFilters = (payload) => ({
    type: STORE_SELECTED_MOVIE_FILTERS,
    payload
})

export const storeSelectedMovieFiltersSucceeded = (payload) => ({
    type: STORE_SELECTED_MOVIE_FILTERS_SUCCEEDED,
    payload
})

export const storeSelectedMoviesSortBy = (payload) => ({
    type: STORE_SELECTED_MOVIES_SORT_BY,
    payload
})

export const storeSelectedMoviesSortBySucceeded = (payload) => ({
    type: STORE_SELECTED_MOVIES_SORT_BY_SUCCEEDED,
    payload
})

export const getSoonInCinemaFilters = (payload) => ({
    type: GET_SOON_IN_CINEMA_FILTERS,
    payload
})

export const getSoonInCinemaFiltersSucceeded = (payload) => ({
    type: GET_SOON_IN_CINEMA_FILTERS_SUCCEEDED,
    payload
})

export const getBoxOfficeGenreFilters = (payload) => ({
    type: GET_BOX_OFFICE_GENRE_FILTERS,
    payload
})

export const getBoxOfficeGenreFiltersSucceeded = (payload) => ({
    type: GET_BOX_OFFICE_GENRE_FILTERS_SUCCEEDED,
    payload
})

export const storeSelectedHour = (payload) => ({
    type: STORE_SELECTED_HOUR,
    payload
})

export const storeSelectedHourSucceeded = (payload) => ({
    type: STORE_SELECTED_HOUR_SUCCEEDED,
    payload
})

export const storeSelectedDate = (payload) => ({
    type: STORE_SELECTED_DATE,
    payload
})

export const storeSelectedDateSucceeded = (payload) => ({
    type: STORE_SELECTED_DATE_SUCCEEDED,
    payload
})

export const redirectUrl = (payload) => ({
    type: REDIRECT_URL,
    payload
})

export const redirectUrlSucceeded = (payload) => ({
    type: REDIRECT_URL_SUCCEEDED,
    payload
})


// WEBPACK FOOTER //
// ./src/SHARED/actions/filters.actions.js